import React, { useState, useEffect } from 'react';
import './styles/components.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Home from './components/Home';
import ProductDetails from './components/ProductDetails';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import CategoryProducts from './components/CategoryProducts';
import CustomDesign from './components/CustomDesign';
import FAQ from './components/FAQ';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';
import SubCategory from './components/subCategory';

import API_ROUTES from './components/config/apiConfig';
import { getPublicRequest } from './api/auth';



function App() {


  const getInitialPage = () => {

    const path = window.location.pathname;


    if(path.startsWith('/category/')) 
      return 'subcategory';


    if(path.startsWith('/products/')) 
      return 'products';


    if(path.startsWith('/product-detail/')) 
      return 'pdp';


    if(path === '/contact-us') 
      return 'contact';


    if(path === '/about') 
      return 'about';


    if(path === '/custom-design') 
      return 'custom-design';


    if(path === '/faq') 
      return 'faq';


    if(path === '/terms') 
      return 'terms';


    if(path === '/privacy') 
      return 'privacy';



    return 'home';

  };





  const getInitialData = () => {


    const path = window.location.pathname;



if (path.startsWith('/category/')) {
  const categoryPath = path.replace('/category/', '');
  const parts = categoryPath.split('/');

  return {
    categorySlug: parts[0] || null,
    subCategorySlug: parts[1] || null,
  };
}




    if(path.startsWith('/products/')){

      return {

        categoryId:path.replace('/products/','')

      };

    }



    if(path.startsWith('/product-detail/')){

      return {

        id:path.replace('/product-detail/','')

      };

    }



    return null;

  };





  const [currentPage,setCurrentPage] = useState(
    getInitialPage()
  );


  const [selectedProduct,setSelectedProduct] = useState(null);


  const [pageData,setPageData] = useState(
    getInitialData()
  );



  const [categories,setCategories] = useState([]);


  const [products,setProducts] = useState([]);







  useEffect(()=>{


    const fetchGlobalData = async()=>{


      try{


        const catRes = await getPublicRequest(
          API_ROUTES.GET_CATEGORIES
        );


        const catData =
          Array.isArray(catRes?.data)
          ? catRes.data
          : catRes?.data?.items || [];


        setCategories(catData);



      }catch(err){

        console.log(err);

      }






      try{


        const prodRes = await getPublicRequest(
          API_ROUTES.GET_PRODUCTS
        );


        const prodData =
          prodRes?.data?.items || [];


        setProducts(prodData);



      }catch(err){

        console.log(err);

      }



    };



    fetchGlobalData();



  },[]);










  useEffect(()=>{


    window.history.replaceState(

      {
        page:getInitialPage(),
        data:getInitialData(),
        product:null
      },

      "",

      window.location.pathname

    );





    const handlePopState = (event)=>{


      const state = event.state;



      if(state){


        setCurrentPage(
          state.page
        );


        setPageData(
          state.data || null
        );


        setSelectedProduct(
          state.product || null
        );


      }

    };



    window.addEventListener(
      "popstate",
      handlePopState
    );



    return ()=>{

      window.removeEventListener(
        "popstate",
        handlePopState
      );

    };


  },[]);









  const navigateTo = (
    pageName,
    data=null
  )=>{


    setCurrentPage(pageName);


    setPageData(data);



    if(pageName==="pdp"){

      setSelectedProduct(data);

    }




    let url="/";




    if (pageName === "subcategory") {
  if (data.subCategorySlug) {
    url = `/category/${data.categorySlug}/${data.subCategorySlug}`;
  } else {
    url = `/category/${data.slug}`;
  }
}





    if(pageName==="products"){

      url=`/products/${data.categoryId}`;

    }



if (pageName === "pdp") {
  url = `/product-detail/${data._id || data.id}`;
}




    if(pageName==="contact"){

      url="/contact-us";

    }




    if(pageName==="about"){

      url="/about";

    }




    if(pageName==="custom-design"){

      url="/custom-design";

    }




    if(pageName==="faq"){

      url="/faq";

    }




    if(pageName==="terms"){

      url="/terms";

    }




    if(pageName==="privacy"){

      url="/privacy";

    }





    window.history.pushState(

      {

        page:pageName,

        data:data,

        product:
          pageName==="pdp"
          ? data
          : null

      },

      "",

      url

    );





    window.scrollTo({

      top:0,

      behavior:"instant"

    });



  };









  return (

    <div className="App">



      <Header

        onNavigate={navigateTo}

        categories={categories}

        products={products}

      />





      <main
        style={{
          minHeight:'65vh',
          position:'relative'
        }}
      >





        {
          currentPage==="home" &&

          <>

            <Hero 
              onNavigate={navigateTo}
            />

            <Home 
              onNavigate={navigateTo}
            />

          </>

        }






{
  currentPage === "subcategory" && (
    pageData?.subCategorySlug ? (

      <CategoryProducts
        categorySlug={pageData?.categorySlug}
        subCategorySlug={pageData?.subCategorySlug}
        onNavigate={navigateTo}
      />

    ) : (

      <SubCategory
        slug={pageData?.categorySlug}
        onNavigate={navigateTo}
      />

    )
  )
}









        {
          currentPage==="products" &&

          <CategoryProducts

            categorySlug={
              pageData?.categoryId
            }

            onNavigate={navigateTo}

          />

        }








        {
          currentPage==="pdp" &&

          <ProductDetails

            product={selectedProduct}

          />

        }







        {
          currentPage==="about" &&

          <AboutUs
            onNavigate={navigateTo}
          />

        }






        {
          currentPage==="contact" &&

          <ContactUs />

        }






        {
          currentPage==="custom-design" &&

          <CustomDesign
            onNavigate={navigateTo}
          />

        }







        {
          currentPage==="faq" &&

          <FAQ
            onNavigate={navigateTo}
          />

        }






        {
          currentPage==="terms" &&

          <TermsConditions
            onNavigate={navigateTo}
          />

        }






        {
          currentPage==="privacy" &&

          <PrivacyPolicy
            onNavigate={navigateTo}
          />

        }





      </main>





      <Footer
        onNavigate={navigateTo}
      />



    </div>

  );

}



export default App;